import {ChoiceFilter, MultiChoiceFilter } from '@model';
import { MeteringType } from '@enums';

export class AlarmFilter {
  meteringType: MeteringType;
  typeMultiChoiceFilter: MultiChoiceFilter;
  stateMultiChoiceFilter: MultiChoiceFilter; // Active/Inactive
}

export class AlarmFilterSettings {
  hotAlarmFilter: AlarmFilter;
  coldAlarmFilter: AlarmFilter;
}

